<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section
        .row.justify-content-md-center
          .col-lg-10.col-md-11
            .heading--section.pad_t--20 Upcoming Events by Affin Hwang

            template(v-if="events.length === 0")
              .pad_t--15
                MessageBar(type="warning")
                  | There is no upcoming events.

            template(v-else)
              .happenings--cards
                .happenings--card(v-for="(event, index) in events")
                  .row.no-gutters
                    .col-lg-4
                      .happenings--card-img
                    .col-lg-8
                      .happenings--card-description
                        .happenings--card-content
                          .happenings--card-org.text--color_grey
                            template(v-for="(organiser, index) in event.organisers")
                              | {{ organiser }}
                              template(v-if="index + 1 < event.organisers.length")
                                | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                          .happenings--card-title
                            | {{ event.name }}
                          .happenings--card-meta.text--color_grey
                            | {{ event.date }} &nbsp;&nbsp; | &nbsp;&nbsp; {{ event.time }} &nbsp;&nbsp; | &nbsp;&nbsp; {{ event.location }}
                      .happenings--card-action
                        .row.no-gutters
                          .col-lg-6
                            a.happenings--card-link.info(:href="event.url", target="_blank") More Information
                          .col-lg-6
                            a.happenings--card-link.register(href="#", @click.prevent="OPEN_REGISTER_POPUP({ eventName: '2H 2019 Market Outlook (Johor Bahru)' })") Register Your Interest

      b-modal#registerInterestModal(ref='happenings_modal', hide-footer, hide-header, size="lg", @hidden="POPUP_HIDDEN")
        .modal--container
          ModalClose(@click.native="HIDE_POPUP")
            
          .form--form
            template(v-if="ui_controls.isSuccessful")
              .form--success
                .form--success-icon
                .form--success-description
                  | This confirms your registration is successful for Affin Hwang Investment Bank’s {{ submit.Event }}. We look forward to welcoming you.

            template(v-else)
              .form--group
                .form--label I'M REGISTERING FOR
                .form--text {{ submit.Event }}

              .form--group(:class="$v.submit.Name.$error ? 'has_error' : ''")
                .form--label FULL NAME as per IC
                input.form--input.form--input_text(type="text", v-model="submit.Name")
                .form--note.form--note_warning(v-if="$v.submit.Name.$error") Please provide a name (required).

              .form--group(:class="$v.submit.Nationality.$error ? 'has_error' : ''")
                .form--label NATIONALITY
                label.form--radio-label
                  input(type="radio", v-model="submit.Nationality", value="malaysian", @change="CLEAR_INPUT_SIMPLE('OtherIdNo')")
                  span Malaysian
                label.form--radio-label
                  input(type="radio", v-model="submit.Nationality", value="others", @change="CLEAR_INPUT_SIMPLE('IcNo')")
                  span Others
                .form--note.form--note_warning(v-if="$v.submit.Nationality.$error") This is mandatory, please select an option.

              .form--group(v-if="isUserMalaysian", :class="$v.submit.IcNo.$error ? 'has_error' : ''")
                .form--label IC NUMBER
                input.form--input.form--input_text(type="text", v-model="submit.IcNo")
                .form--note.form--note_warning(v-if="$v.submit.IcNo.$error") Please provide IC number in format <strong>000000-00-0000</strong>
                .form--note(v-else) <strong>Example</strong>: 760602-10-6081

              .form--group(v-if="isUserForeigner", :class="$v.submit.OtherIdNo.$error ? 'has_error' : ''")
                .form--label PASSPORT NUMBER
                input.form--input.form--input_text(type="text", v-model="submit.OtherIdNo")
                .form--note.form--note_warning(v-if="$v.submit.OtherIdNo.$error") Please provide a passport number

              .form--group(:class="$v.submit.MobileNo.$error ? 'has_error' : ''")
                .form--label MOBILE NUMBER
                input.form--input.form--input_text(type="text", v-model="submit.MobileNo")
                .form--note.form--note_warning(v-if="$v.submit.MobileNo.$error") Please provide a valid phone number
                .form--note(v-else) Please provide a valid phone number as this contact number may be used to send event updates

              .form--group(:class="$v.submit.Email.$error ? 'has_error' : ''")
                .form--label EMAIL ADDRESS
                input.form--input.form--input_text(type="text", v-model="submit.Email")
                .form--note.form--note_warning(v-if="$v.submit.Email.$error") Please provide a valid email address
                .form--note(v-else) Please provide a valid email address as this email address may be used to send event updates

              .form--action
                a.button.button-secondary(href="#", @click.prevent="SUBMIT_FORM")
                  | Register for this event
                .form--note.form--note_warning(v-if="ui_controls.showFormError") {{ error.current }}

              .form--overlay(v-if="ui_controls.isLoadingSending")
                .form--overlay-content
                  img(src='../assets/images/form--loading.svg', alt="")

          .form--footnote.pad_t--30
            p <strong>Disclaimer:</strong> By registering for the event, you permit Affin Hwang Investment Bank Berhad and Macquarie Capital Securities (M) Sdn Bhd ("Organisers") to process, access and use your personal data for the purpose of this event, subject to the respective privacy notice/personal data notice of the Organisers. If you take part in a group photograph at the event, you agree that you do so voluntarily and on the basis that you consent to the fact that your image may be displayed (including on the Organisers’ website or any other website and on printed publications) and made available to other customers, and may be used by the Organisers for promotional purposes. Due to the number of people in a group photograph, you will not be able to withdraw your consent once the photograph has been taken.

            p By registering for the event, you confirm that you agree to allow the Organisers to use your personal data for the purposes of marketing and advertising of financial products and services whether by (a) any of the Organisers (b) companies within the Organiser’s group of companies or (c) companies outside the Organiser’s group (e.g. its merchant and strategic partners); You may view the Organisers’ privacy notice/personal data notice with regard to collection and management of personal data in Affin Hwang Investment Berhad’s website at http://affinhwang.com/privacy and Macquarie Capital Securities (M) Sdn. Bhd. website at https://www.macquarie.com/my/about/disclosures/privacy-and-cookies
</template>



<script>
import { validationMixin } from 'vuelidate';
import { required, email, requiredIf } from 'vuelidate/lib/validators'

import requestHandlers from '../mixins/requestHandlers';

import Loading from '../components/Loading';
import MessageBar from '../components/MessageBar';
import ModalClose from '../components/ModalClose';

export default {
  name: 'Happenings',

  mixins: [requestHandlers, validationMixin],

  components: {
    Loading,
    MessageBar,
    ModalClose
  },

  data() {
    return {
      events: [
        /*
        {
          organisers: ['affin hwang investment bank', 'macquarie capital securities'],
          name: '2019 market outlook (johor bahru)',
          date: 'saturday, 6 july 2019',
          time: '8.30am - 1.30pm',
          location: 'grand paragon hotel, johor bahru',
          url: '//happenings.affinhwang.com/market-outlook-jb',
        }
        */
      ],
      ui_controls: {
        showFormError: false,
        isLoadingSending: false,
        isSuccessful: false,
      },

      error: {
        current: '',
      },

      submit: {
        Event: '',
        Name: '',
        Nationality: 'malaysian',
        IcNo: '',
        OtherIdNo: '',
        MobileNo: '+60',
        Email: '',
        ExistingClient: 'true',
        OtherInfo: '',
      }
    }
  },

  validations: {
    submit: {
      Name: {
        required,
      },
      Nationality: {
        required,
      },
      IcNo: {
        required: requiredIf(function(nestedModel) {
          return this.isUserMalaysian;
        }),
        isValidNRIC: function(value) {
          return /^\d{6}-\d{2}-\d{4}$/.test(value) || value === '';
        }
      },
      OtherIdNo: {
        required: requiredIf(function(nestedModel) {
          return this.isUserForeigner;
        }),
      },
      MobileNo: {
        required,
        isValidMobileNumber: function(value) {
          return /^\+\d{10,12}$/.test(value) || /^\d{10,12}$/.test(value);
        }
      },
      Email: {
        required,
        email
      },
      ExistingClient: {
        required,
      },
    }
  },

  computed: {
    isUserMalaysian() {
      return this.submit.Nationality === 'malaysian';
    },
    isUserForeigner() {
      return this.submit.Nationality === 'others';
    }

  },

  methods: {
    CLEAR_INPUT_SIMPLE(input) {
      this.submit[input] = '';
    },

    OPEN_REGISTER_POPUP(payload) {
      // Set event name if exists
      let { eventName } = payload;

      if(eventName) {
        this.submit.Event = eventName;
      }

      // Show popup modal
      this.$refs.happenings_modal.show();
    },

    HIDE_POPUP() {
      this.$refs.happenings_modal.hide();
    },

    SUBMIT_FORM() {
      this.TRIGGER_VALIDATION();

      if(this.$v.submit.$error || this.$v.submit.$invalid) {
        this.SCROLL_TO_TOP_OF_POPUP();
        return;
      }

      this.MAKE_REQUEST();
    },

    MAKE_REQUEST() {
      this.INIT_REQUEST();
      let getURL = 'https://api.affinhwang.com/EventRegistration/Register';

      let _payload = { };

      Object.keys(this.submit).forEach(key => {

        if(key === 'Nationality') {
          return;
        }

        if(this.isUserMalaysian && key === 'OtherIdNo') {
          return;
        }

        if(this.isUserForeigner && key === 'IcNo') {
          return;
        }

        if(this.isUserForeigner && key === 'OtherIdNo') {
          _payload.IcNo = this.submit[key];
          return;
        }

        _payload[key] = this.submit[key];
      });

      this.$axios.post(getURL, _payload)
      .then(response => {
        if(response.status === 201) {
          this.ui_controls.isSuccessful = true;
          this.SCROLL_TO_TOP_OF_POPUP();
        }
      })
      .catch(error => {
        this.error.current = error.response.status === 400 ? error.response.data : this.error.default;
        this.ui_controls.showFormError = true;
      })
      .then(response => this.END_REQUEST());
    },

    INIT_REQUEST() {
      this.ui_controls.isLoadingSending = true;
      this.ui_controls.showFormError = false;
    },

    END_REQUEST() {
      this.ui_controls.isLoadingSending = false;
    },

    TRIGGER_VALIDATION() {
      this.$v.submit.$touch();
    },

    SCROLL_TO_TOP_OF_POPUP() {
      this.$jQuery("#registerInterestModal").scrollTop(0);
    },

    POPUP_HIDDEN() {
      this.RESET_FORM();
    },

    RESET_FORM() {
      this.ui_controls.showFormError = false;
      this.ui_controls.isSuccessful = false;
      this.ui_controls.isLoadingSending = false;
      this.$v.$reset();

      Object.keys(this.submit).forEach(key => {
        if(key === 'MobileNo') {
          this.submit[key] = '+60';
        } else if(key === 'Nationality') {
          this.submit[key] = 'malaysian';
        } else if(key === 'ExistingClient') {
          this.submit[key] = 'true';
        } else {
          this.submit[key] = '';
        }
      });
    },

  },

  created() {
  },
}

</script>




<style lang="scss">
  .happenings {

  }

  .happenings--cards {
    padding: 30px 0;
  }
  .happenings--card {

  }
  .happenings--card + .happenings--card {
    margin-top: 30px;
  }
  .happenings--card-img {
    height: 250px;
    background: #333;
  }
  .happenings--card-description {
    background: #fff;
    min-height: 210px;
    position: relative;

    @include MQ(SM) {
      min-height: 0;
      padding: 20px 0;
    }
    @include MQ(XS) {
      padding: 10px 0;
    }
  }
  .happenings--card-content {
    position: absolute;
    top: 50%;
    left: 0; right: 0;
    transform: translateY(-50%);

    @include MQ(SM) {
      position: static;
      transform: translateY(0);
    }
  }
  .happenings--card-org {
    padding: 0 30px 15px;
    text-transform: uppercase;
    font-size: 90%;
  }
  .happenings--card-title {
    padding: 10px 30px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    @include font-size($happenings-heading);
    font-weight: 700;
    color: #111;
    text-transform: uppercase;
    color: $color-primary;
  }
  .happenings--card-meta {
    padding: 15px 30px 0;
    text-transform: uppercase;
    font-size: 90%;
  }
  .happenings--card-action {

  }
  .happenings--card-link {
    display: block;
    background: red;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 80%;
    color: #fff;

    &.info {
      background: $color-body_grey;
    }
    &.info:hover {
      background: $color-body_grey_dark;
    }

    &.register {
      background: $color-secondary;
    }
    &.register:hover {
      background: $color-body_grey_dark;
    }

    &:hover, &:focus, &:active {
      color: #fff;
      text-decoration: none;
    }
  }


  .happenings--past {
    padding-top: 80px;
  }
  .happenings--past-heading {
    // @include font-size($generic-h3);
  }
  .happenings--past-carousel {
    margin-top: 20px;
  }
  .happenings--past-card {
    background: #fff;
    // box-shadow: $box-shadow-pattern_global;

    @include MQ(SM) {
      margin-bottom: 20px;
    }
  }
  .happenings--past-card-img {

  }
  .happenings--past-card-content {
    padding: 15px 30px;
  }
  .happenings--past-card-title {
    // @include primaryFont700;
  }
  .happenings--past-card-date {
    color: $color-body-text;
    padding-top: 5px;
  }
</style>
